<form *ngIf="!resetSuccess" (ngSubmit)="resetPassword()" #resetForm="ngForm">

  <hb-auth-input type="password" name="currentPassword" placeholder="Current password" icon="lock"
    [control]="currentPasswordFormControl"
    [showError]="currentPasswordError || (currentPasswordError && currentPasswordFormControl.hasError('required'))">
  </hb-auth-input>

  <hb-auth-input type="password" name="newPassword" placeholder="New password" icon="lock"
    [control]="passwordFormControl"
    [showError]="resetPasswordError || (resetPasswordError && passwordFormControl.hasError('required'))">
  </hb-auth-input>

  <hb-auth-input type="password" name="confirmNewPassword" placeholder="Confirm new password" icon="lock"
    [control]="verifyPasswordFormControl"
    [showError]="resetPasswordError || (resetPasswordError && verifyPasswordFormControl.hasError('required'))">
  </hb-auth-input>

  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <div
          *ngIf="resetPasswordError && passwordFormControl.hasError('required') || resetPasswordError && verifyPasswordFormControl.hasError('required') || currentPasswordError && currentPasswordFormControl.hasError('required')"
          class="font-danger">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Required field</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <button class="btn btn-primary px-4">Reset Password</button>
      </div>
    </div>
    <div class="col-6" *ngIf="showCancel">
      <button class="btn btn-primary px-4 pull-right" type="button" (click)="cancel()">Cancel</button>
    </div>

  </div>
  <div class="row">
    <div class="col-12">
      <div *ngIf="resetPasswordError || currentPasswordError" class="alert alert-danger white-space-pre-wrap">
        {{resetPasswordErrorMessage}}</div>
    </div>
  </div>
</form>

<form *ngIf="resetSuccess" (ngSubmit)="continue()" #resetForm="ngForm">
  <p class="text-muted">
    <b>{{statusMessage}}</b>
  </p>
  <div class="row" *ngIf="showContinue">
    <div class="col-6">
      <div class="form-group">
        <button class="btn btn-primary px-4">Continue</button>
      </div>
    </div>
  </div>
</form>

<p-messages [(value)]="messages"></p-messages>